export default __webpack_public_path__ + "images/c68dc1165c6c001158d5531c1fbba48e.svg";